import React from 'react';

export const DoubleCell45 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 87 87"
      {...props}
    >
      <circle cx={43.5} cy={43.5} r={43.5} fill="#fff" />
      <path
        fill="#fff"
        stroke="#27375f"
        strokeMiterlimit="10"
        strokeWidth="1.15px"
        d="M40.87 38.95H30.36l-5.26 9.1 5.26 9.11h10.51l5.26-9.11-5.26-9.1z"
      />
      <path
        fill="#fff"
        stroke="#27375f"
        strokeMiterlimit="10"
        strokeWidth="1.15px"
        d="M40.87 57.16H30.36l-5.26 9.1 5.26 9.11h10.51l5.26-9.11-5.26-9.1zM40.87 20.74H30.36l-5.26 9.1 5.26 9.11h10.51l5.26-9.11-5.26-9.1zM56.64 29.84H46.13l-5.26 9.11 5.26 9.1h10.51l5.26-9.1-5.26-9.11z"
      />
      <path
        fill="#fff"
        stroke="#27375f"
        strokeMiterlimit="10"
        strokeWidth="1.15px"
        d="M56.64 48.05H46.13l-5.26 9.11 5.26 9.1h10.51l5.26-9.1-5.26-9.11zM56.64 11.63H46.13l-5.26 9.11 5.26 9.1h10.51l5.26-9.1-5.26-9.11z"
      />
    </svg>
  );
};
